import {
  AppointmentMapperImpl,
  ChatMapperImpl,
  CouponMapperImpl,
  FinancialMapperImpl,
  NotificationMapperImpl,
  PatientMapperImpl,
  PaymentMapperImpl,
  PlanMapper,
  ScheduleMapperImpl,
  SubsMapper,
  UserMapperImpl,
} from "@phurshell/psiapp-frontend-core/data";
import { useSessionStore } from "@/store/useSessionStore";
import { cpfFormatter, currencyFormatter, stringFormatter } from "./formatters";

export const userMapper = new UserMapperImpl();
export const appointmentMapper = new AppointmentMapperImpl(
  stringFormatter,
  cpfFormatter,
  userMapper,
  () => useSessionStore().session?.id,
);
export const financialMapper = new FinancialMapperImpl(currencyFormatter);
export const chatMapper = new ChatMapperImpl();
export const subsMapper = new SubsMapper();
export const planMapper = new PlanMapper(currencyFormatter);
export const paymentMapper = new PaymentMapperImpl();
export const scheduleMapper = new ScheduleMapperImpl();
export const notificationMapper = new NotificationMapperImpl();
export const patientMapper = new PatientMapperImpl();
export const couponMapper = new CouponMapperImpl();
